// const store = "../store/index.js";

const initFbSdk = (Vue, facebookClientId, store) => {
  return new Promise((resolve) => {   
    window.fbAsyncInit = () => {      
      window.FB.init({
        appId: facebookClientId,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v9.0",
      });     
      Vue.FB = window.FB;      
      window.FB.Event.subscribe("send_to_messenger", function(e) {
        // callback for events triggered by the plugin

        if (e.event == "opt_in") {
          store.dispatch("toggleDisplay");
        }
      });
    

      window.FB.Event.subscribe("messenger_checkbox", function(e) {
        // console.log(e);
        if (e.event == "rendered") {
          // console.log(e);
          store.dispatch("setCheckboxRendered", true);
        } else if (e.event == "checkbox") {
          store.state.checkBoxUserRef = e.user_ref;
          store.state.checkBoxState = e.state;
        } else if (e.event == "not_you") {
          // console.log("");
        } else if (e.event == "hidden") {
          // console.log("");
        }
      });
      resolve("success");
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        window.fbAsyncInit();        
      }   
     
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

exports.initFbSdk = initFbSdk;
